import { useEffect } from 'react'
import {getListVariables} from '../../../services/sKPI/variable.service'
import { useDispatch } from 'react-redux';
import { action_setFiltredVariableList, action_setVariableList } from '../../../reducers/actions/KPI/actions';


const useGetVariablesMaintainer = (variables, setVariables) => {    
    const dispatch = useDispatch();

    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListVariables();
                const response = serviceResponse.data;

                setVariables && setVariables(response.data);

                if (setVariables === undefined) {
                    dispatch(action_setVariableList(response.data));
                    dispatch(action_setFiltredVariableList(response.data));
                }
            }
            catch (error) {
                setVariables && setVariables([]);

                if (setVariables === undefined) {
                    dispatch(action_setVariableList([]));
                    dispatch(action_setFiltredVariableList([]));
                }
            }
        }
        
        if (variables === null) {
            getData()
        }
    }, [variables, setVariables]);
}

const useGetVariablesMaintainer2 = (variables, setVariables) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListVariables();
                const response = serviceResponse.data;

                setVariables(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: response.data
                }));
            }
            catch (error) {
                setVariables(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
            }
        }
        
        if (variables.data === null) {
            getData()
        }
    }, [variables, setVariables]);
}

export {
    useGetVariablesMaintainer,
    useGetVariablesMaintainer2,
}